<template>
  <div>
    <v-list dense nav class="py-0">
      <!-- CLOSE -->
      <v-list-item v-if="side == 'right'" style="padding: 0 !important">
        <v-list-item-action>
          <v-btn
            fab
            small
            depressed
            color="#D8E0E6"
            @click="closeNavDrawer()"
            style="border-radius: 40px"
          >
            <v-icon x-small>$icon-close</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <!-- LOGO -->
      <v-list-item
        class="flex-center logo-list-item"
        style="margin-bottom: 16px !important"
        v-else
      >
        <v-img
          :src="require('../assets/images/logo.svg')"
          max-width="64px"
          style="z-index: 1"
        ></v-img>
      </v-list-item>
      <!-- USER -->
      <v-menu
        open-on-hover
        bottom
        offset-x
        close-on-content-click
        close-on-click
      >
        <template v-slot:activator="{ on, attrs }">
          <v-list-item two-line class="px-0" v-bind="attrs" v-on="on">
            <v-badge
              v-if="getRanking().length > 0 && getRanking() < 3"
              overlap
              :content="
                getRanking() == '0'
                  ? '1'
                  : getRanking() == '1'
                  ? '2'
                  : getRanking() == '2'
                  ? '3'
                  : ''
              "
              :color="
                getRanking() == '0'
                  ? '#ffc121'
                  : getRanking() == '1'
                  ? '#bcc5cc'
                  : getRanking() == '2'
                  ? '#ab8626'
                  : '#26ab5e'
              "
            >
              <v-avatar
                size="40"
                :class="
                  getRanking() == '0'
                    ? 'avatar-1st'
                    : getRanking() == '1'
                    ? 'avatar-2nd'
                    : getRanking() == '2'
                    ? 'avatar-3rd'
                    : 'avatar'
                "
              >
                <v-img :src="avatar"></v-img>
              </v-avatar>
            </v-badge>
            <v-avatar
              v-else
              size="40"
              :class="
                getRanking() == '0'
                  ? 'avatar-1st'
                  : getRanking() == '1'
                  ? 'avatar-2nd'
                  : getRanking() == '2'
                  ? 'avatar-3rd'
                  : 'avatar'
              "
            >
              <v-img :src="avatar"></v-img>
            </v-avatar>
            <v-list-item-content style="margin-left: 16px !important">
              <v-list-item-title class="user-title">{{
                getUser().name
              }}</v-list-item-title>
              <v-list-item-subtitle class="user-subtitle">
                <span>{{
                  isPremium() ? "Utilizador premium" : "Utilizador normal"
                }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list>
          <v-list-item link to="/configuracoes">
            <v-list-item-title>Definições</v-list-item-title>
          </v-list-item>
          <div v-if="isAdmin()">
            <v-list-item link to="/backoffice/dashboard" v-if="!isBackoffice()">
              <v-list-item-title>Backoffice</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/" @click.stop="showAdmin = false" v-else>
              <v-list-item-title>Bigodds</v-list-item-title>
            </v-list-item>
          </div>
        </v-list>
      </v-menu>

      <v-divider style="border: none"></v-divider>

      <!-- NAV ITEMS -->
      <v-list-item
        v-for="item in navItems"
        :key="item.title"
        link
        :to="item.href"
        style="margin: 16px 0 !important"
      >
        <v-list-item-icon>
          <v-badge
            :content="getNotifications()"
            :value="getNotifications()"
            color="#F83030"
            overlap
            left
            v-if="item.title == 'Alertas'"
          >
            <v-icon>$icon-bell</v-icon>
          </v-badge>
          <v-icon v-else>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <div class="bottom-btns">
        <div v-if="!isBackoffice()">
          <!-- Telegram Image -->
          <v-list-item class="flex-center hide-mini telegram-img">
            <v-img
              :src="require('../assets/images/image1.png')"
              max-width="140px"
              style="z-index: 1"
            ></v-img>
          </v-list-item>
          <!-- Telegram Card -->
          <v-list-item>
            <v-btn
              class="hide-hover"
              color="#26AB5E"
              block
              depressed
              width="50"
              height="40"
              @click.stop="telegramDialog = true"
              style="bottom: 64px"
            >
              <v-icon color="#FFFFFF">mdi-telegram</v-icon>
            </v-btn>
            <v-card id="telegram" flat color="#F7F9FA">
              <div></div>
              <v-card-title>Telegram Bigodds</v-card-title>
              <v-card-subtitle
                >Junta-te à nossa comunidade no telegram</v-card-subtitle
              >
              <v-card-text>
                <v-row>
                  <v-col cols="1" style="padding: 0 0 0 12px">
                    <v-icon size="12">$icon-info</v-icon>
                  </v-col>
                  <v-col style="padding: 0 16px; text-align: left">
                    A partilha destes links dá direito a exclusão imediata da
                    comunidade Bigodds.
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="primary"
                  block
                  depressed
                  @click.stop="telegramDialog = true"
                  >Ver links</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-list-item>
        </div>
        <!--Logout -->
        <v-list-item>
          <v-btn
            class="hide-hover"
            color="#FFE5E5"
            block
            depressed
            width="50"
            height="40"
            @click.stop="logoutDialog = true"
            style="bottom: 40px"
          >
            <v-icon size="16" color="#F83030">$icon-logout</v-icon>
          </v-btn>
          <v-btn
            class="logout-btn"
            color="#FFE5E5"
            block
            depressed
            @click.stop="logoutDialog = true"
          >
            <v-icon small left color="#F83030">$icon-logout</v-icon>Logout
          </v-btn>
        </v-list-item>
      </div>
    </v-list>
    <!-- TELEGRAM LINKS -->
    <v-dialog v-model="telegramDialog" max-width="275">
      <v-list dense>
        <v-list-item style="margin-left: 0 !important">
          <v-list-item-content>
            <v-list-item-title class="links-title">Apostas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <div v-for="(link, index) in links" :key="'link-' + index">
          <v-list-item
            class="links-item"
            link
            @click="goToLink(link.url)"
            v-if="link.label == 'BigAdepto' || isPremium()"
          >
            <v-list-item-content>
              <v-list-item-title>{{ link.label }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon>
                <v-icon class="arrow-right" small color="#9AABB8"
                  >mdi-chevron-right</v-icon
                >
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </div>
        <v-list-item style="padding-bottom: 12px">
          <v-list-item-content class="flex-center">
            <v-btn
              class="close-btn"
              depressed
              color="#D8E0E6"
              height="40"
              @click.stop="telegramDialog = false"
              >Fechar</v-btn
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-dialog>
    <!-- LOGOUT DIALOG -->
    <v-dialog v-model="logoutDialog" max-width="349">
      <v-card>
        <v-card-title align="center">Sair da conta</v-card-title>
        <v-card-text>Tem a certeza que pretende sair?</v-card-text>
        <v-list-item style="padding-bottom: 12px">
          <v-list-item-content style="padding-right: 8px">
            <v-btn
              block
              depressed
              color="secondary"
              height="48"
              @click="logout()"
              >Sim</v-btn
            >
          </v-list-item-content>
          <v-list-item-content style="padding-left: 8px">
            <v-btn
              block
              depressed
              color="primary"
              height="48"
              @click="logoutDialog = false"
              >Cancelar</v-btn
            >
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<style scoped>
.v-icon {
  color: #9aabb8;
}
.v-navigation-drawer--mini-variant .v-list .v-list-item {
  margin: 0 !important;
  padding: 0 4px;
}
.v-navigation-drawer--mini-variant .logo-list-item .v-image {
  max-width: 42px !important;
}
.v-navigation-drawer--mini-variant .hide-mini {
  display: none;
}
.v-navigation-drawer--mini-variant .logout {
  margin-top: 312px;
}
.hide-hover {
  display: none;
}
.v-navigation-drawer--mini-variant .hide-hover {
  display: initial;
}
.links-title {
  font-family: Gilroy-Bold;
  font-size: 14px;
  line-height: 24px;
  color: #304351 !important;
  padding-top: 16px;
}
.v-dialog .v-list-item--link {
  background-color: #f3f6f7;
  height: 40px;
  padding-right: 0;
  border-radius: 6px;
  margin: 8px 16px !important;
}
.arrow-right {
  background-color: #d8e0e6;
  width: 16px !important;
  height: 16px !important;
  border-radius: 16px;
}
.close-btn {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #9aabb8;
  text-transform: capitalize;
  width: 176px;
  max-width: 176px;
  border-radius: 6px !important;
}
.bottom-btns {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
@media only screen and (max-height: 812px) {
  .telegram-img {
    display: none;
  }
  #telegram.v-sheet.v-card {
    padding-top: 0 !important;
  }
  #telegram {
    width: 100%;
  }
  #telegram >>> .v-card__title,
  #telegram >>> .v-card__subtitle,
  #telegram >>> .v-card__text {
    display: none;
  }
  #telegram >>> .v-card__actions {
    padding: 0;
  }
}
@media only screen and (max-height: 568px) {
  .bottom-btns {
    position: relative;
    top: 64px;
  }
}
</style>

<script>
import AuthService from "../services/auth.service";

export default {
  name: "NavigationDrawer",
  components: {},
  props: {
    side: String,
  },
  data: () => ({
    showAdmin: false,
    sidebarMenu: false,
    toggleMini: false,
    telegramDialog: false,
    logoutDialog: false,
    alerts: 27,
    links: [
      {
        label: "BigAdepto",
        url: "https://t.me/BigAdepto",
      },
      {
        label: "Prognósticos Oficiais",
        url: "https://t.me/joinchat/AAAAAEy71vizKFwcjmCusw",
      },
      {
        label: "Apostas ao vivo",
        url: "https://t.me/joinchat/AAAAAFMdYokA5DPbSN2lnA",
      },
      {
        label: "Apostas Auxiliares Bigodds ",
        url: "https://t.me/joinchat/AAAAAE8kLs5Dj1DoCdb_Mw",
      },
      {
        label: "Desafios",
        url: "https://t.me/joinchat/AAAAAEkUHkgaUue6aVdjdA",
      },
      {
        label: "Chat",
        url: "https://t.me/joinchat/Eu3nXxyLaDtNOkOrFQeaMw",
      },
      {
        label: "Geral",
        url: "https://t.me/joinchat/AAAAAEegznhKI6dorvZYxQ",
      },
    ],
    items: [
      { title: "Dashboard", href: "/", icon: "$icon-dashboard" },
      {
        title: "Prognósticos",
        href: "/prognosticos",
        icon: "$icon-prognosis",
      },
      {
        title: "Tiro Certeiro",
        href: "/tiro-certeiro",
        icon: "$icon-bullseye",
      },
      {
        title: "Bigómetro",
        href: "/bigometro",
        icon: "$icon-charts",
      },
      { title: "Notícias", href: "/noticias", icon: "$icon-news" },
      { title: "Alertas", href: "/alertas", icon: "$icon-bell" },
    ],
    backofficeItems: [
      {
        title: "Dashboard",
        href: "/backoffice/dashboard",
        icon: "$icon-dashboard",
      },
      {
        title: "Jogos",
        href: "/backoffice/jogos",
        icon: "$icon-ball",
      },
      {
        title: "Prognósticos",
        href: "/backoffice/prognosticos",
        icon: "$icon-prognosis",
      },
      {
        title: "Tiro Certeiro",
        href: "/backoffice/tiro-certeiro",
        icon: "$icon-bullseye",
      },
      {
        title: "Base de Dados",
        href: "/backoffice/base-de-dados",
        icon: "$icon-file",
      },
      {
        title: "Faturas",
        href: "/backoffice/faturas",
        icon: "$icon-invoice",
      },
      {
        title: "Utilizadores",
        href: "/backoffice/utilizadores",
        icon: "$icon-user",
      },
      {
        title: "Website",
        href: "/backoffice/website",
        icon: "$icon-charts",
      },
      { title: "Notícias", href: "/backoffice/noticias", icon: "$icon-news" },
    ],
    photo: "avatar.png"
  }),
  methods: {
    closeNavDrawer() {
      this.$emit("close-nav-drawer");
    },
    logout() {
      AuthService.logout();
    },
    getUser() {
      return this.$store.state.user;
    },
    getRanking() {
      return this.$store.state.ranking;
    },
    getNotifications() {
      return this.$store.state.user.unread;
    },
    isAdmin() {
      return this.$store.state.admin;
    },
    isPremium() {
      return this.$store.state.premium;
    },
    goToLink(url) {
      window.open(url, "_blank");
    },
    isBackoffice() {
      return this.$route.path.includes("backoffice");
    },
  },
  computed: {
    avatar() {
      const photo = this.$store.state.user.photo;
      if (photo) {
        return photo;
      } else {
        return require("../assets/images/avatar.png");
      }
    },
    navItems() {
      return this.isBackoffice() ? this.backofficeItems : this.items;
    },
  },
};
</script>